import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {
	const btnState = props?.active ? "clicked" : "default";
	const button   = theme.other.colors.secondaryBtn;

	const hasBorder = !props?.noBorder;

	const hoverColor           = props?.active ? button[btnState].text : button.hover.text;
	const hoverBackgroundColor = props?.active ? button[btnState].background : button.hover.background;
	const hoverBorderColor     = props?.active ? button[btnState].border : button.hover.border;

	const BorderWidth = hasBorder ? theme.other.darkMode ? "1px" : "2px" : "0px";

	const padding      = props?.size === "small" ? "0.5rem 2rem" : "1rem 3rem";
	const borderRadius = props?.size === "small" ? "0.8rem" : "1rem";
	const fontSize     = props?.size === "small" ? "1.3rem" : "1.6rem";

	return (
		 {
			secondaryButton: {
				background    : button[btnState].background,
				borderRadius  : theme.other.isMobile ? "0.5rem" : borderRadius,
				...( hasBorder && { outline: `${ BorderWidth } solid ${ button[btnState].border }` } ),
				textTransform : "none",
				padding       : padding,
				...( props?.fullWidth && { width: "100%" } ),
				outline       : "none",
				border        : "none",
				"&:hover"     : {
					color      : hoverColor,
					background : hoverBackgroundColor,
					...( hasBorder && { outline: `${ BorderWidth } solid ${ hoverBorderColor }` } )
				},
				height: "fit-content"
			},
			buttonText: {
				color      : button[btnState].text,
				fontWeight : theme.other.typographyNew.fontWeightMapping[props?.fontWeight],
				fontSize   : fontSize
			}
		}
	 );
} );